var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ls-badge",class:_vm.themedClass},[_c('div',{staticClass:"ls-badge--badge",class:[
      _vm.themedClass.length ? _vm.bgColor : ("has-background-" + _vm.bgColor),
      [_vm.rounded ? 'ls-badge--badge-rounded' : 'ls-badge--badge-default'] ]},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }